export const ROUTES = {
  Home: '/',
  WebOTP: '/web-otp',
  DraggableRect: '/draggable-rect',
  MapLeaflet: '/map-leaflet',
  MapGoogle: '/map-google',
};
